import { z } from 'zod'
import { HouseholdId, UserId } from './ids.ts'

export const User = z.object({
	id: UserId,
	householdId: HouseholdId,
	email: z.email(),
	displayName: z.string().min(1).max(100).nullable(),
	createdAt: z.iso.datetime(),
	// Apple's stable user ID, once linked. Kept on the user row so moving
	// households knows to repoint the USERAPPLE# pointer too. Defaulted so
	// rows written before Apple sign-in parse.
	appleSub: z.string().nullable().default(null),
})
export type User = z.infer<typeof User>
